export default /* glsl */`
varying vec2 vUv;
varying vec3 vColor;

uniform vec3 color;

void main() {

    vUv = uv;
    vColor = color;

    gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4( position, 1.0 );

}
`;
